import React, { Fragment, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import SkillFormDialog from '../CV/SkillFormDialog';
import Button from "@material-ui/core/Button";
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import "moment/locale/ka"
import moment from "moment"

import { connect } from 'react-redux'
import { TableHead, Typography } from '@material-ui/core';
import { setSnackBar } from '../../models/application/applicationActions'

import { environment } from '../../environment/environment';
import { CVSkill } from '../../models/cv/cv';
import { ConfirmationDialog } from '../Dialogs/ConfirmationDialog';
import { cvService } from '../../models/cv/service';

const BASE_URL = environment.basePath

const useStyles2 = makeStyles({
    table: {
        minWidth: 500,
    },
});



moment.locale("ka")

const SkillTableListComponent = (props) => {
    const { skills, onReload, setSnackBar, id, user } = props
    const classes = useStyles2();
    const [items, setItems] = useState<CVSkill[]>([]);
    const [dialog, setDialog] = useState({ open: false, item: null, reload: false });
    const [page, setPage] = useState(0);
    const [confirmation, setConfirmation] = useState({ open: false, text: '', callback: null })
    const [rowsPerPage, setRowsPerPage] = useState(5);


    let emptyRows

    useEffect(() => {
        if (skills) {
            setItems(skills)
        }
    }, [skills])

    useEffect(() => {
        if (items.length) {
            emptyRows = rowsPerPage - Math.min(rowsPerPage, items.length - page * rowsPerPage);
        }
    }, [items])

    const tableContent = (<TableContainer component={Paper}>
        <Table className={classes.table} aria-label="custom pagination table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>
                        უნარი
                    </TableCell>
                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        დონე
                    </TableCell>
                    <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    (rowsPerPage > 0
                        ? items?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : items
                    ).map((item: CVSkill) => (
                        <TableRow key={item.id}>
                            <TableCell align="center">
                                {item.skill.name}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {item.level.name}
                            </TableCell>
                            <TableCell style={{ width: 160 }} align="center">
                                <DeleteIcon style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setConfirmation({
                                            text: 'ნამდვილად გსურთ ჩანაწერის წაშლა?', open: true, callback: (value) => {
                                                if (value) {
                                                    cvService.delete(`skills_${item.id}`).then(resp => {
                                                        if (resp.id) {
                                                            onReload()
                                                            setSnackBar({ vertical: 'bottom', horizontal: 'center', text: 'უნარი წარმატებით წაიშალა.', open: true })
                                                        }
                                                    })
                                                }
                                                setConfirmation({ text: '', callback: null, open: false })
                                            }
                                        })
                                    }} />
                                <CreateIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setDialog({ open: true, reload: false, item })
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                    </TableRow>
                )}
            </TableBody>
        </Table>
    </TableContainer>)

    return <Fragment>
        <ConfirmationDialog 
            title="ჩანაწერის წაშლა"
            open={confirmation.open} 
            text={confirmation.text} callback={confirmation.callback} />
        <SkillFormDialog 
            existing={items?.map(i => i.skill.id)}
            onOpen={dialog.open} onClose={(open) => {
            onReload()
            setDialog({ ...dialog, open })
        }} item={dialog.item} />
         {user?.id === id && <Button color="primary" variant="outlined" onClick={() => {
            setDialog({ open: true, reload: false, item: null })
        }}>
            ახალი ჩანაწერი
        </Button>}
        {items?.length > 0 ? <div>{tableContent}</div> : <div style={{ marginTop: 20 }}>
            <Typography variant="h6">
                ჩანაწერები არ მოიძებნა
            </Typography>
        </div>}
    </Fragment >
}

const mapStateToProps = (state: any) => {
    return {
        user: state?.auth?.user
    }
}

export default connect(mapStateToProps, { setSnackBar })(SkillTableListComponent)